<template>
  <v-container class="form-container rounded-lg">
    <h1>Edit site text</h1>
    <EditForm :fields="fields" name="language" />
  </v-container>
</template>

<script>
import { markRaw } from "vue";
import TextField from "@/Admin/components/form/TextField.vue";

import { ruleSetGen } from "@/Admin/helpers/rules";
import EditForm from "@/Admin/components/EditForm.vue";
import config from "@/helpers/api";
export default {
  name: "LanguageEditView",
  components: { EditForm },
  data() {
    return {
      fields: {
        field: {
          component: markRaw(TextField),
          data: {
            label: "Field",
            placeholder: "Enter field name",
            name: "field",
            disabled: true,
            rules: ruleSetGen.text("Enter correct speciality name", true, 3),
          },
        },
        value: {
          component: markRaw(TextField),
          data: {
            label: "Value",
            placeholder: "Enter value",
            name: "value",
            rules: ruleSetGen.text("Enter correct speciality name", true, 3),
          },
        },
      },
    };
  },
  async created() {
    await fetch(`${config.baseURL}/language/${this.$route.params.id}`, {
      method: "GET",
      headers: config.headers,
    })
      .then((response) => response.json())
      .then((response) => {
        for (const key in this.fields) {
          this.fields[key].data.value = response.data[key];
        }
      });
  },
};
</script>

<style scoped>
.form-container {
  width: 1000px;
  margin: auto;
  background-color: white;
  padding: 10px;
}
</style>
